import { useTranslation } from 'react-i18next';
import type { Widget } from './model';

/** A widget's title: the person's own, else the type's (a Bar chart is named after its metric). */
export function useWidgetTitle() {
  const { t } = useTranslation('dashboardWidgets');
  return (w: Widget) => {
    const own = w.cfg.title.trim();
    if (own) return own;
    if (w.type === 'chart') return t(`chart.metric.${w.cfg.metric}`);
    return t(`defaultTitle.${w.type}`);
  };
}
